// extracted by mini-css-extract-plugin
module.exports = {"text":"SessionIdContainer_text__J5nfz"};